<div class="row">
	<ng-container *ngIf="!request.employeeIds">
		<div
			class="col-sm-4 col-md-3 col-lg"
			*ngxPermissionsOnly="PermissionsEnum.CHANGE_SELECTED_EMPLOYEE"
		>
			<nb-card
				[nbSpinner]="loading"
				nbSpinnerSize="giant"
				nbSpinnerStatus="primary"
				class="mb-0"
			>
				<nb-card-body>
					<p>
						{{ 'REPORT_PAGE.MEMBERS_WORKED' | translate }}
					</p>
					<div class="h1">
						{{ counts?.employeesCount || 0 }}
					</div>
				</nb-card-body>
			</nb-card>
		</div>
	</ng-container>
	<ng-container *ngIf="!request.projectIds">
		<div class="col-sm-4 col-md-3 col-lg">
			<nb-card
				[nbSpinner]="loading"
				nbSpinnerSize="giant"
				nbSpinnerStatus="primary"
				class="mb-0"
			>
				<nb-card-body>
					<p>
						{{ 'REPORT_PAGE.PROJECTS_WORKED' | translate }}
					</p>
					<div class="h1">
						{{ counts?.projectsCount || 0 }}
					</div>
				</nb-card-body>
			</nb-card>
		</div>
	</ng-container>
	<div class="col-sm-4 col-md-3 col-lg">
		<nb-card
			[nbSpinner]="loading"
			nbSpinnerSize="giant"
			nbSpinnerStatus="primary"
			class="mb-0"
		>
			<nb-card-body>
				<p>
					{{ 'REPORT_PAGE.ACTIVITY' | translate }}
				</p>
				<div class="h1">{{ counts?.weekActivities || 0 }}%</div>
			</nb-card-body>
		</nb-card>
	</div>
	<div class="col-sm-4 col-md-3 col-lg">
		<nb-card
			[nbSpinner]="loading"
			nbSpinnerSize="giant"
			nbSpinnerStatus="primary"
			class="mb-0"
		>
			<nb-card-body>
				<p>
					{{ 'REPORT_PAGE.TOTAL_HOURS' | translate }}
				</p>
				<div class="h1">
					{{ counts?.weekDuration || 0 | durationFormat }}
				</div>
			</nb-card-body>
		</nb-card>
	</div>
</div>
